import {
  WebShopProductListViewedEvent,
  WebShopProductSelectedEvent,
} from '../../../../b2c/webshop/home/HomePageEvents';
import { WebShopProductViewedEvent } from '../../../../b2c/webshop/product/ProductPageEvents';
import { IEventAggregator } from '../../EventAggregator';
import { Analytics } from '../Analytics';
import { AnalyticsLists } from '../AnalyticsLists';
import { ProductDataConverter } from '../converters/ProductDataConverter';

export class WebShopAnalyticsListener {
  constructor(eventAggregator: IEventAggregator) {
    eventAggregator.subscribe(WebShopProductListViewedEvent, (e) => this.onWebShopProductListViewed(e));
    eventAggregator.subscribe(WebShopProductSelectedEvent, (e) => this.onWebShopProductSelected(e));
    eventAggregator.subscribe(WebShopProductViewedEvent, (e) => this.onWebShopProductViewed(e));
  }

  private onWebShopProductListViewed(e: WebShopProductListViewedEvent) {
    const listName = AnalyticsLists.webShopHome(e.storeContext.store.displayName);

    Analytics.trackViewProductList({
      currency: e.storeContext.currency.code,
      listName,
      products: e.products.map((p) => ProductDataConverter.fromWebShopProductListData(p, listName)),
    });
  }

  private onWebShopProductSelected(e: WebShopProductSelectedEvent) {
    const listName = AnalyticsLists.webShopHome(e.storeContext.store.displayName);

    Analytics.trackSelectProduct({
      currency: e.storeContext.currency.code,
      listName,
      product: ProductDataConverter.fromWebShopProductListData(e.product, listName, e.index + 1),
    });
  }

  private onWebShopProductViewed(e: WebShopProductViewedEvent) {
    Analytics.trackViewProduct({
      currency: e.price.currency.code,
      value: e.price.amount * e.quantity,
      product: ProductDataConverter.fromWebShopProductDetailsData(
        e.product,
        e.configurationCode,
        e.price.amount,
        e.quantity,
      ),
    });
  }
}
